@if (isLoading()) {
  <div class="row">
    @for (i of [1,2,3]; track i) {
      <div class="col-lg-4">
        <p-skeleton height="215px" width="100%"></p-skeleton>
      </div>
    }
  </div>
} @else {
  @for (group of groupedUtilityRates; track $index) {
    <div class="card">
      <div class="card-header bg-light d-flex justify-content-between align-items-center">
        <div class="card-title">
          <i class="la-share-alt las"></i>
          {{ 'CONTRACT.PROVIDER' | translate }} - {{ group.provider.name }}
        </div>

        <div class="actions d-flex justify-content-between gap-2">
          <button (click)="onEdit(group)" class="btn btn-primary btn-sm" *ngCan="'utility-provider-configurations.update'">
            <i class="las la-edit"></i>
            {{ 'EDIT' | translate }}
          </button>

          <button (click)="onDelete(group)" class="btn btn-danger btn-sm" *ngCan="'utility-provider-configurations.destroy'">
            <i class="las la-minus"></i>
            {{ 'DELETE' | translate }}
          </button>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          @for (rate of group.rates; track $index) {
            <div class="col-lg-4 col-md-6">
              <utility-rate-card [data]="rate"/>
            </div>
          }
        </div>
      </div>
    </div>
  } @empty {
    <div class="text-center" style="margin-top: 4rem; margin-bottom: 4rem;">
      <h4>
        <i class="la la-exclamation-triangle me-2"></i>
        <span>{{ 'PROPERTY.NO_CONFIGURATIONS' | translate }}</span>
      </h4>
    </div>
  }

}
